import { NavLink, links } from "./links";
import { useCustomerPermissions } from "@/hooks/useCustomerPermissions";
import { useBankRequisitesAvailable } from "@/hooks/useBankRequisitesAvailable";

/**
 * Фильтрует ссылки на основе разрешений клиента
 */
export const filterLinksByPermissions = (links: NavLink[]): NavLink[] => {
    // Этот хук должен вызываться внутри компонента, поэтому создадим функцию-обертку
    // которая будет использоваться в компонентах
    return links;
};

/**
 * Хук для получения отфильтрованных ссылок на основе разрешений
 */
export const useFilteredLinks = (): NavLink[] => {
    const permissions = useCustomerPermissions();
    const { isAvailable: bankRequisitesAvailable } = useBankRequisitesAvailable();
    
    return links.filter(link => {
        // Фильтруем Exchange
        if (link.title === "Exchange" && !permissions.exchangeTabEnabled) {
            return false;
        }
        
        // Фильтруем Deposit
        if (link.title === "Deposit" && !permissions.depositMethodsEnabled) {
            return false;
        }
        
        // Фильтруем Withdraw
        if (link.title === "Withdraw" && !permissions.withdrawMethodsEnabled) {
            return false;
        }
        
        // Фильтруем Invoices (Счета)
        if (link.title === "Invoices" && !permissions.accountsTabEnabled) {
            return false;
        }
        
        // Фильтруем подссылки Deposit
        if (link.subLinks && link.title === "Deposit") {
            // Сначала проверяем общее разрешение
            if (!permissions.depositMethodsEnabled) {
                return false; // Скрываем всю секцию депозитов
            }
            
            link.subLinks = link.subLinks.filter(subLink => {
                // Фильтруем Bank если нет банковских реквизитов
                if (subLink.requiresBankRequisites && !bankRequisitesAvailable) {
                    return false;
                }
                // Фильтруем по детальным разрешениям
                if (subLink.title === "CreditCard" && !permissions.depositCardEnabled) {
                    return false;
                }
                if (subLink.title === "Bank" && !permissions.depositBankEnabled) {
                    return false;
                }
                if (subLink.title === "Crypto" && !permissions.depositCryptoEnabled) {
                    return false;
                }
                return true;
            });
            // Если все подссылки отфильтрованы, скрываем и родительскую ссылку
            if (link.subLinks.length === 0) {
                return false;
            }
        }
        
        // Фильтруем подссылки Withdraw
        if (link.subLinks && link.title === "Withdraw") {
            // Сначала проверяем общее разрешение
            if (!permissions.withdrawMethodsEnabled) {
                return false; // Скрываем всю секцию выводов
            }
            
            link.subLinks = link.subLinks.filter(subLink => {
                // Фильтруем по детальным разрешениям
                if (subLink.title === "Card" && !permissions.withdrawCardEnabled) {
                    return false;
                }
                if (subLink.title === "Bank" && !permissions.withdrawBankEnabled) {
                    return false;
                }
                if (subLink.title === "Crypto" && !permissions.withdrawCryptoEnabled) {
                    return false;
                }
                return true;
            });
            // Если все подссылки отфильтрованы, скрываем и родительскую ссылку
            if (link.subLinks.length === 0) {
                return false;
            }
        }
        
        return true;
    });
};

